import React, { useEffect } from 'react';
import { FlightButton } from '@flybits/design-system';

import { getBrowserLanguageCode } from 'helpers/language.helper';

import './SignedOut.scss';

const SIGNED_OUT_COPY = {
  en: {
    title: 'Signed Out | Experience Studio @ Flybits',
    header: 'Signed Out',
    paragraph1: 'You are currently signed out of Experience Studio. Please sign in again to continue.',
    paragraph2:
      "You can return to the Flybits sign-in page by clicking the button below, otherwise return to your organization's SSO sign-in page to continue.",
    buttonLabel: 'Return to Flybits sign-in',
  },
  fr: {
    title: 'Déconnecté | Experience Studio @ Flybits',
    header: 'Déconnecté',
    paragraph1: "Vous êtes actuellement déconnecté d'Experience Studio. Veuillez vous reconnecter pour continuer.",
    paragraph2:
      'Vous pouvez revenir à la page de connexion Flybits en cliquant sur le bouton ci-dessous, ou revenir à la page de connexion SSO de votre organisation pour continuer.',
    buttonLabel: 'Retour à la connexion Flybits',
  },
} as const;

const language = getBrowserLanguageCode(Object.keys(SIGNED_OUT_COPY) as (keyof typeof SIGNED_OUT_COPY)[]);
const copy = SIGNED_OUT_COPY[language];

export default function SignedOut() {
  const ssoUrl = (process.env.REACT_APP_SSO_URL || '').trim();
  useEffect(() => {
    document.title = copy.title;
  }, []);

  return (
    <div className="signed-out">
      <div className="header">{copy.header}</div>
      <div className="description">
        <p> {copy.paragraph1} </p>
        <p> {copy.paragraph2} </p>
        <FlightButton theme="link" label={copy.buttonLabel} onClick={() => window.location.replace(ssoUrl || '/')} />
      </div>
    </div>
  );
}
